import { texts } from '../../locale'
import { SilhouettesContainer, Silhouette } from './styled'
import { Icon1 } from './icon1'
import { Icon2 } from './icon2'
import { Icon3 } from './icon3'
import { Icon4 } from './icon4'
import { Icon5 } from './icon5'
import IconText from './iconText'

export const SilhouettesContent = () => (
  <SilhouettesContainer>
    <Silhouette $ani>
      <Icon1 />
      <IconText
        ani
        name={texts.silhouettes_1}
        sentence={texts.silhouettes_2}
        direction="left"
      ></IconText>
    </Silhouette>
    <Silhouette $ani>
      <Icon2 />
      <IconText
        ani
        name={texts.silhouettes_3}
        sentence={texts.silhouettes_4}
        direction="left"
      ></IconText>
    </Silhouette>
    <Silhouette $ani>
      <Icon3 />
      <IconText
        ani
        name={texts.silhouettes_5}
        sentence={texts.silhouettes_6}
        direction="left"
      ></IconText>
    </Silhouette>
    <Silhouette $ani>
      <Icon4 />
      <IconText
        ani
        name={texts.silhouettes_7}
        sentence={texts.silhouettes_8}
        direction="right"
      ></IconText>
    </Silhouette>
    <Silhouette $ani>
      <Icon5 />
      <IconText
        ani
        name={texts.silhouettes_9}
        sentence={texts.silhouettes_10}
        direction="right"
      ></IconText>
    </Silhouette>
  </SilhouettesContainer>
)
